export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=40d25aca1dac64a52341a278fa40f75269ed2861fd&name=addToFolderEventAction!'